export const DateFormats = ["yyyy-MM-dd", "MM/dd/yyyy", "dd/MM/yyyy"]
export const DateTimeFormats = ["yyyy-MM-dd HH:mm:ss", "MM/dd/yyyy HH:mm:ss", "dd/MM/yyyy HH:mm:ss"]